import { useMemo, useState } from "react";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

const ReadMoreText = ({ text = "", line = 2, color = "#333F48" }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const content = String(text ?? "").trim();
  const lineCount = Math.max(1, Number(line) || 2);

  const clampStyle = useMemo(() => {
    if (isExpanded) return {};
    return {
      display: "-webkit-box",
      WebkitLineClamp: lineCount,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    };
  }, [isExpanded, lineCount]);

  const charThreshold = lineCount === 1 ? 70 : lineCount === 2 ? 140 : 200;
  const showToggle = content.length > charThreshold;

  if (!content) return null;

  return (
    <div className="relative">
      <p
        style={clampStyle}
        className="text-sm font-light text-[#333F48] break-words leading-relaxed"
      >
        {content}
      </p>

      {showToggle && (
        <button
          type="button"
          style={{ color }}
          className="mt-1 flex items-center gap-1 text-sm italic font-medium hover:underline"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded((prev) => !prev);
          }}
        >
          {isExpanded ? "Read less" : "Read more"}
          <MdOutlineArrowBackIosNew
            size={16}
            className={isExpanded ? "rotate-90" : "-rotate-90"}
          />
        </button>
      )}
    </div>
  );
};

export default ReadMoreText;
